"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AmazonIVSPlayer = AmazonIVSPlayer;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _usePlayer = _interopRequireDefault(require("./usePlayer"));
var _usePlayerScript = _interopRequireDefault(require("./usePlayerScript"));
var _AmazonIVSPlayer = require("./AmazonIVSPlayer.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function AmazonIVSPlayer(_ref) {
  var playbackUrl = _ref.playbackUrl,
    height = _ref.height,
    muted = _ref.muted,
    playbackWaitingMessage = _ref.playbackWaitingMessage,
    onPlaybackStarted = _ref.onPlaybackStarted;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isPlayerReady = _useState2[0],
    setIsPlayerReady = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isPlayerLoading = _useState4[0],
    setIsPlayerLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isPlayerUnsupported = _useState6[0],
    setIsPlayerUnsupported = _useState6[1];
  var videoRef = (0, _react.useRef)(null);
  (0, _usePlayerScript["default"])(setIsPlayerReady, setIsPlayerUnsupported, document, window);
  (0, _usePlayer["default"])(videoRef, isPlayerReady, setIsPlayerLoading, playbackUrl);
  (0, _react.useEffect)(function () {
    if (!isPlayerLoading) {
      onPlaybackStarted();
    }
  }, [isPlayerLoading]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isPlayerUnsupported ? /*#__PURE__*/_react["default"].createElement(_AmazonIVSPlayer.StyledCaption, {
    className: "unsupported-player"
  }, "Player is not supported!") : null, isPlayerLoading && /*#__PURE__*/_react["default"].createElement(_AmazonIVSPlayer.StyledLoadingIndicator, null, /*#__PURE__*/_react["default"].createElement(_AmazonIVSPlayer.LoadingText, null, playbackWaitingMessage), /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
    size: "lg",
    color: "primary"
  })), /*#__PURE__*/_react["default"].createElement("video", {
    style: {
      visibility: isPlayerLoading ? 'hidden' : ''
    },
    ref: videoRef,
    playsInline: true,
    autoPlay: true,
    height: height,
    controls: true,
    muted: muted
  }));
}
AmazonIVSPlayer.defaultProps = {
  playbackWaitingMessage: 'Spinning up the reactor...',
  height: 300,
  muted: false,
  onPlaybackStarted: function onPlaybackStarted() {
    return null;
  }
};
AmazonIVSPlayer.propTypes = {
  playbackWaitingMessage: _propTypes["default"].string,
  playbackUrl: _propTypes["default"].string.isRequired,
  height: _propTypes["default"].number,
  muted: _propTypes["default"].bool,
  onPlaybackStarted: _propTypes["default"].func
};